import {Directive, EventEmitter, HostListener, input, Output} from '@angular/core';

@Directive({
			   selector: '[SwipeElement]'
		   })
export class SwipeDirective {
	@Output() swipeLeft = new EventEmitter<void>();
	@Output() swipeRight = new EventEmitter<void>();


	swipeDisabled = input<boolean>(false);

	private touchStartX = 0;
	private touchStartY = 0;
	private readonly minSwipeDistance = 50; // Adjust threshold as necessary

	@HostListener('touchstart', ['$event'])
	onTouchStart(event: TouchEvent): void {
		if (this.swipeDisabled()) return;
		if (event.touches.length === 1) {
			this.touchStartX = event.touches[0].clientX;
			this.touchStartY = event.touches[0].clientY;
		}
	}

	@HostListener('touchend', ['$event'])
	onTouchEnd(event: TouchEvent): void {
		if (this.swipeDisabled()) return;
		if (event.changedTouches.length === 1) {
			const touchEndX = event.changedTouches[0].clientX;
			const touchEndY = event.changedTouches[0].clientY;

			const deltaX = touchEndX - this.touchStartX;
			const deltaY = touchEndY - this.touchStartY;

			// Check for primarily horizontal swipe
			if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > this.minSwipeDistance) {
				if (deltaX > 0) {
					this.swipeRight.emit();
				} else {
					this.swipeLeft.emit();
				}
			}
		}
	}
}
